import { Store, UpdateStoreRequest, UpdateStoreResponse } from "@functions-types";
import { makeCloudFunction } from "../makeCloudFunction";

export type { Store };
export const updateStore = makeCloudFunction<
  UpdateStoreRequest,
  UpdateStoreResponse
>("store", "updateStore");
